import React from 'react';

import {Stack} from '@mui/material';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {LifeplaceBanner} from './Banner';
import {LifeplaceProducts} from './Products';

export const Lifeplace = () => {
	const {isEnabled: showProducts} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_LIFEPLACE);
	const {isEnabled: showBanner} = useFeatureFlag(FeaturesEnum.PORTAL_FEATURE_LIFEPLACE_BANNER);

	if (!showBanner && !showProducts) return null;

	return (
		<Stack gap={3}>
			{showBanner ? <LifeplaceBanner /> : null}
			{showProducts ? <LifeplaceProducts /> : null}
		</Stack>
	);
};
